import axios from 'axios';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const url = import.meta.env.VITE_API_BASE_URL; //'http://localhost:8080/lims'
export const Instance = axios.create({
  baseURL: url
});
